'use client';

import { Stack } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

import { cssStyles } from '../..';

export const SectionBackgroundStyle = styled( Stack )(({ theme }) => ({
  padding: theme.spacing( 8, 0 ),
  ...cssStyles( theme ).bgGradient( {
    direction: 'top',
    startColor: alpha( theme.palette.grey[500], 0 ),
    endColor: alpha( theme.palette.grey[500], 0.12 ),
  } ),
  [theme.breakpoints.up( 'md' )]: { padding: theme.spacing( 10, 0 ) },
}));
